/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const FinancialSettings = {

	get (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/financial-settings"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinancialLimitsModules (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/financial-settings/financial-limits-modules"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinancialLimitsModulesPercentage (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/financial-settings/financial-limits-modules-percentage"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinancialLimitsModulesPercentageDotation (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/financial-settings/financial-limits-modules-percentage-dotation"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinancialLimitsPossibilities (context, contestId, perLegalForm, moduleNumber, onSuccess, onError, options) {
		Api.get(context,
			"/financial-settings/financial-limits-possibilities"
			+ "?contestId=" + contestId
			+ "&perLegalForm=" + perLegalForm
			+ "&moduleNumber=" + moduleNumber
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getModuleConfigured (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/financial-settings/module-configured"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOfferData (context, contestId, moduleNumber, countryId, mainBidderId, onSuccess, onError, options) {
		Api.get(context,
			"/financial-settings/offer-data"
			+ "?contestId=" + contestId
			+ "&moduleNumber=" + moduleNumber
			+ "&countryId=" + countryId
			+ "&mainBidderId=" + mainBidderId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postFinancialLimits (context, contestId, properties, onSuccess, onError, options) {
		Api.post(context,
			"/financial-settings/financial-limits"
			+ "?contestId=" + contestId
			, properties
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postFinancialLimitsModules (context, contestId, modulesConfigList, onSuccess, onError, options) {
		Api.post(context,
			"/financial-settings/financial-limits-modules"
			+ "?contestId=" + contestId
			, modulesConfigList
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postFinancialLimitsModulesPercentage (context, contestId, modulesConfigValues, onSuccess, onError, options) {
		Api.post(context,
			"/financial-settings/financial-limits-modules-percentage"
			+ "?contestId=" + contestId
			, modulesConfigValues
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postFinancialLimitsModulesPercentageDotation (context, contestId, modulesConfigValues, onSuccess, onError, options) {
		Api.post(context,
			"/financial-settings/financial-limits-modules-percentage-dotation"
			+ "?contestId=" + contestId
			, modulesConfigValues
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, contestId, constraints, onSuccess, onError, options) {
		Api.put(context,
			"/financial-settings"
			+ "?contestId=" + contestId
			, constraints
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
